import React from 'react';
import {connect} from 'react-redux';
import uuid from "uuid";

import {setDiscountSections} from "./discountsActions";
import {defaultDiscount, DISCOUNT_MAIN_TYPES, DISCOUNT_SECTION_TYPES, DISCOUNT_FINANCE_CELLS} from "./discountsInterface";
import TextInput from "../Generic/textInput";
import {getNextMaxNumberFromList} from "../../utilities";
import {getCurrentWorkSheetSections, getUpdatedSections} from "./discountsFunctions";


const DiscountsFinancing = (props) => {
  const {discountSections, setDiscountSections, workSheetsActiveIndex} = props;
  const financeSection = getCurrentWorkSheetSections(discountSections, workSheetsActiveIndex)
    .find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);

  if (!financeSection) {
    return null
  }

  const addFinanceOption = () => {
    let newSections = discountSections.map(sec => {
      if (sec.id === financeSection.id) {
        const uuidId = uuid.v4();
        financeSection.discounts.push(Object.assign({}, defaultDiscount, {
          id: uuidId,
          uuId: uuidId,
          discountType: DISCOUNT_MAIN_TYPES.finance,
          name: "",
          order: getNextMaxNumberFromList(financeSection.discounts, "order"),
          financePercentage: 0,
          financeMonths: 0,
          financeSalesPercentage: 0,
        }))
      }
      return sec
    })
    setDiscountSections(newSections);
  }

  const updateDiscount = (discount, property, value) => {
    let newSections = getUpdatedSections(discountSections,
      financeSection,
      discount,
      property,
      value
    )
    setDiscountSections(newSections);
  }

  const removeDiscount = (discount) => {
    setDiscountSections(discountSections.map((sec) => {
      if (sec.id === financeSection.id) {
        sec.discounts = sec.discounts.filter((dis) => dis.id !== discount.id)
      }
      return sec
    }));
  };

  return (
    <div className="discounts-body__sections">
      <div className={"discounts-section"}>
        <div className={"discounts-section__header"}>
          <div className="discounts-section__header-name">
            <button className="discounts-header__buttons-item" onClick={addFinanceOption}>+ Finance Options</button>
          </div>
        </div>
        <ul className="discounts-section__discounts">
        {financeSection.discounts.map(discount => {
          return (
            <li className="discount-finance__item flex flex--center flex--between" key={discount.id}>
              <div className="flex-item flex flex--center flex--between">
                {Object.keys(DISCOUNT_FINANCE_CELLS).map(property => {
                  return (
                    <div className="" key={property}>
                      <TextInput className={"ui-input ui-input--gray4 ui-input--gray4--small text-center"}
                        // placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.name"})}
                                 placeholder=""
                                 numberInput={true}
                                 onChange={(value) => updateDiscount(discount, property, value)}
                                 value={property === "financeMonths" ? "" + discount[property] : discount[property] + "%"}/>
                      <span className={"margin-l8 text-uppercase font--14 bold"}>{DISCOUNT_FINANCE_CELLS[property]}</span>
                    </div>
                  )
                })}
              </div>
              <div className="discount-cell discount-cell--delete margin-l24">
                <button className="ui-icon-remove" onClick={() => removeDiscount(discount)}/>
              </div>
            </li>
          )
        })}
        </ul>
      </div>
    </div>
  )
}

const mapStateToProps = (store) => {
  const {workSheetsActiveIndex, discountSections} = store.discountsState;
  return {
    discountSections,
    workSheetsActiveIndex,
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsFinancing);
